import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const errorState = '&[data-error] > input + div'
const errorCheckedState = '&[data-error] > input:checked:not([disabled]) + div'
const disabledCircleState = '&[disabled]:not(:checked) + div'
const disabledCheckedCircleState = '&:checked[disabled] + div'
const checkedState = '&:not([data-error]) > input:checked:not([disabled]) + div'
const hoverCircleState = '&:hover:not([data-error]) > input:not([disabled]) + div, &[data-hover]:not([data-error]) > input:not([disabled]) + div'

export default function initStyle() {
  return [registerThemeSpec('cmp.radio', {
    wrapper: {
      position: 'relative',
      height: 32,
      verticalAlign: 'middle',
      userSelect: 'none',
      display: 'inline-flex',
      mr: 72,
      fontSize: '14px',
      alignItems: 'center',
      cursor: composeStyle.when('disabled')
        .truthy('not-allowed')
        .falsy('pointer'),
      color: composeStyle.when('disabled')
        .truthy('palette.body.disable')
        .falsy('body'),
      [hoverCircleState]: {
        borderColor: 'brand',
      },
      [errorState]: {
        borderColor: 'danger',
      },
      [errorCheckedState]: {
        '& > div': {
          transform: 'scale(1)',
          bg: 'danger',
        },
      },
      [checkedState]: {
        borderColor: 'brand',
        '& > div': {
          transform: 'scale(1)',
          bg: 'brand',
        },
      },
    },
    radioInput: {
      border: '0',
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: '1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px',
      opacity: '0',
      [disabledCircleState]: {
        borderColor: 'palette.outline.disable',
      },
      [disabledCheckedCircleState]: {
        borderColor: 'palette.brand.disable',
        '& > div': {
          transform: 'scale(1)',
          bg: 'palette.brand.disable',
        },
      },
    },
    control: {
      minWidth: 16,
      width: 16,
      height: 16,
      boxSizing: 'border-box',
      borderRadius: 'circle',
      border: 'outlineoutline',
      bg: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    controlChecked: {
      width: 8,
      height: 8,
      transform: 'scale(0)',
      transition: 'all .3s linear',
      transformOrigin: '50% 50%',
      borderRadius: 'circle',
    },
    label: {
      ml: 8,
      display: 'flex',
      alignItems: 'center',
    },
  })]
}
